import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

const NotreHistoirePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <img 
          src="/assets/images/bague-or-18-carats-diamants-aupiho-joaillerie.jpeg"
          alt="Bague en or 18 carats avec diamants - Aupiho Joaillerie"
          className="absolute inset-0 w-full h-full object-cover object-center"
          style={{ position: 'fixed' }}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide" style={{ fontFamily: 'MoonTime, cursive' }}>
              Notre Histoire
            </h1>
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-12 h-px bg-[#c69c70]"></div>
              <SparklesIcon className="h-8 w-8 text-[#c69c70]" />
              <div className="w-12 h-px bg-[#c69c70]"></div>
            </div>
            <p className="text-xl text-white/90 font-light max-w-2xl mx-auto">
              Une passion transmise de génération en génération
            </p>
          </div>
        </div>
      </section>

      {/* Notre Histoire - Contenu principal */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-6xl mx-auto items-center">
            <div className="order-2 md:order-1">
              <div className="space-y-6 text-gray-700 leading-relaxed text-base">
                <p>
                  <strong className="text-[#c69c70]">Aupiho</strong>, œuf l'Horloger de Besiktas, passionnée par les bijoux, dès son passage remarquée par les femmes de sa famille. 
                  Les découvertes et l'initiation aux belles parures et aux belles pierres <strong>ont façonné sa vocation</strong>.
                </p>
                
                <p>
                  <strong className="text-[#c69c70]">Sa naissance AUPIHO</strong><br />
                  Aujourd'hui, les bijoux symbolisent <strong>ses dépôts</strong>, sa haute qualité, sa noblesse <strong>et sa grandeur et sa beauté intemporelle</strong>. Avec des ans sont une une énergie de ses dédicé aux femmes elle il est d'agrémenter la vie quotidienne et ses moments de préciosité et ses réflexions individuels.
                </p>
                
                <p>
                  <strong className="text-[#c69c70]">Le savoir-faire</strong><br />
                  Grâce à l'efficacité sont et Fernand, la marque AUPIHO repose sur un <strong>savoir-faire d'artisanat</strong>, des nôtres, générations et des espèces qui sera la clé du dépassement dans une <strong>qualitiés à la française</strong>.
                </p>
                
                <p>
                  <strong className="text-[#c69c70]">La création</strong><br />
                  Maître en son art, elle allient des dessins, L'AUPIHO des bijoux, les bijoux entrapés sur une qualité artisanale par une bijoux entrapés finais des métiers pour tous ou pour qualité.
                </p>
                
                <p>
                  <strong className="text-[#c69c70]">L'éthique</strong><br />
                  Nos matières AUPIHO sont <strong>fabriquées dans le respect de l'homme</strong> et des processus environnementaux, tout en long de notre production. Aussi éthique fondamentals pour la Normandie et des professionnels des bijoux pour deux étages.
                </p>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <div className="relative overflow-hidden rounded-2xl shadow-xl">
                <img 
                  src="/assets/images/DSC00572-1-1-1-scaled.jpg" 
                  alt="Fondatrice Aupiho" 
                  className="w-full h-full object-cover aspect-[3/4]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#c69c70]/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotreHistoirePage;

